import {
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { FormPopupComponent } from '../../../../components';
import { CarrierFormComponent } from '../carrier-form/carrier-form.component';
import { CarrierDto, CarriersClient, UpdateCarrierCommand } from '@services';
import notify from 'devextreme/ui/notify';

@Component({
    selector: 'edit-carrier-form',
    imports: [FormPopupComponent, CarrierFormComponent],
    templateUrl: './edit-carrier-form.component.html',
})
export class EditCarrierFormComponent {
    @ViewChild(CarrierFormComponent, { static: false }) editNewForm: CarrierFormComponent;
    
    @Input() isReadOnly: boolean = false;
    @Input() carrierId: string;
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onSave = new EventEmitter();

    private carriersClient = inject(CarriersClient);

    formData: CarrierDto = {} as CarrierDto;

    loadCarrierById = (id: any) => {
        this.carriersClient.getCarrier(id).subscribe({
            next: (data: CarrierDto) => {
                this.formData = data;
            },
            error: () => {},
        });
    };

    onPopupSaveClick = () => {
        let formData = this.editNewForm.getData();

        let updateCommand = new UpdateCarrierCommand({
            id: this.carrierId,
            number: formData.number,
            status: formData.status,
            name: formData.name,
            scac: formData.scac,
            address: formData.address,
            phone: formData.phone,
            email: formData.email,
        });

        this.carriersClient.updateCarrier(updateCommand).subscribe({
            next: async () => {
                this.visible = false;
                this.visibleChange.emit(this.visible);
                this.onSave.emit();
            },
            error: (errors: Array<any>) => {
                errors.forEach((errMsg) => {
                    notify(
                        {
                            message: errMsg.message,
                            type: 'error',
                            displayTime: 5000,
                        },
                        {
                            position: 'bottom right',
                            direction: 'up-push',
                        },
                    );
                });
            },
        });
    };

    onVisibleChange(visible: boolean) {
        this.visibleChange.emit(visible);
    }

    protected onOpen() {
        this.loadCarrierById(this.carrierId);
    }
}
